import "../css/header.scss";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";
import { FiChevronDown, FiShoppingBag } from "react-icons/fi";
import { STORE_CONFIG } from "../config/store";
import { POLICY_LINKS } from "../config/policyLinks";

function Header() {
  const { cartItems } = useContext(CartContext);
  const [isMoreOpen, setIsMoreOpen] = useState(false);
  const moreRef = useRef(null);
  const itemCount = cartItems.reduce((total, item) => total + item.quantity, 0);
  const toTop = () => {
    setIsMoreOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const close = (event) => {
      if (event.key === "Escape" || !moreRef.current || !moreRef.current.contains(event.target)) setIsMoreOpen(false);
    };
    document.addEventListener("keydown", close);
    document.addEventListener("pointerdown", close);
    return () => {
      document.removeEventListener("keydown", close);
      document.removeEventListener("pointerdown", close);
    };
  }, []);

  return (
    <header className="site-header">
      <div className="top-banner">Thoughtful goods, packed in {STORE_CONFIG.operatingRegion}</div>
      <div className="main-header">
        <div className="logo-container">
          <Link to="/" onClick={toTop} className="logo-link" aria-label={`${STORE_CONFIG.brand} home`}>
            <svg className="brand-mark" viewBox="0 0 58 58" aria-hidden="true">
              <path d="M29 7c12 0 22 10 22 22S41 51 29 51 7 41 7 29 17 7 29 7Z" />
              <path d="M19 29c0-8 4-14 10-18 6 4 10 10 10 18s-4 14-10 18c-6-4-10-10-10-18Z" />
              <circle cx="43" cy="14" r="3" />
            </svg>
            <span className="brand-lockup">
              <span className="logo-title">{STORE_CONFIG.brand}</span>
              <span className="logo-subtitle">GIFTS WITH A BRIGHT SIDE</span>
            </span>
          </Link>
        </div>
        <div className="user-cart-container">
          <Link to="/cartpage" className="icon-link cart-link" aria-label={`Cart with ${itemCount} items`}>
            <FiShoppingBag className="icon cart-icon" />
            <span className="cart-badge">{itemCount}</span>
          </Link>
        </div>
      </div>
      <nav className="navigation" aria-label="Primary navigation">
        <ul className="nav-list">
          <li className="nav-item"><Link to="/shop" onClick={toTop}>Shop</Link></li>
          <li className="nav-item"><Link to="/about" onClick={toTop}>About</Link></li>
          <li className="nav-item"><Link to="/contact" onClick={toTop}>Contact Us</Link></li>
          <li className="nav-item more-item" ref={moreRef}>
            <button type="button" className="more-toggle" aria-expanded={isMoreOpen} aria-controls="more-menu" onClick={() => setIsMoreOpen((open) => !open)}>
              More <FiChevronDown aria-hidden="true" />
            </button>
            {isMoreOpen && (
              <ul className="more-menu" id="more-menu">
                {POLICY_LINKS.map(([label, path]) => <li key={path}><Link to={path} onClick={toTop}>{label}</Link></li>)}
              </ul>
            )}
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
